var focusableRegex = /^(?:a|input|select|option|textarea|button|object)$/i;
var NODE_NAME_PREDICATES = {};

var toClassList = function toClassList(classNames) {
  return String(classNames).trim().split(' ');
};
/**
 * @hidden
 */


export var hasClasses = function hasClasses(element, classNames) {
  var namesList = toClassList(classNames);
  return Boolean(toClassList(element.className).find(function (className) {
    return namesList.indexOf(className) >= 0;
  }));
};
/**
 * @hidden
 */

export var matchesClasses = function matchesClasses(classNames) {
  return function (element) {
    return hasClasses(element, classNames);
  };
};
/**
 * @hidden
 */

export var matchesNodeName = function matchesNodeName(nodeName) {
  if (!NODE_NAME_PREDICATES[nodeName]) {
    NODE_NAME_PREDICATES[nodeName] = function (element) {
      return String(element.nodeName).toLowerCase() === nodeName.toLowerCase();
    };
  }

  return NODE_NAME_PREDICATES[nodeName];
};
/**
 * @hidden
 */

export var closest = function closest(node, predicate) {
  while (node && !predicate(node)) {
    node = node.parentNode;
  }

  return node;
};
/**
 * @hidden
 */

export var closestInScope = function closestInScope(node, predicate, scope) {
  while (node && node !== scope && !predicate(node)) {
    node = node.parentNode;
  }

  if (node !== scope) {
    return node;
  }
};
/**
 * @hidden
 */

export var contains = function contains(parent, node, matchSelf) {
  if (matchSelf === void 0) {
    matchSelf = false;
  }

  var outside = !closest(node, function (child) {
    return child === parent;
  });

  if (outside) {
    return false;
  }

  var el = closest(node, function (child) {
    return child === node;
  });
  return el && (matchSelf || el !== parent);
};
/**
 * @hidden
 */

export var isVisible = function isVisible(element) {
  var rect = element.getBoundingClientRect();
  var hasSize = rect.width > 0 && rect.height > 0;
  var hasPosition = rect.x !== 0 && rect.y !== 0; // Elements can have zero size due to styling, but they still count as visible.
  // For example, the selection checkbox has no size, but is made visible through styling.

  return (hasSize || hasPosition) && window.getComputedStyle(element).visibility !== 'hidden';
};
/**
 * @hidden
 */

export var isFocusable = function isFocusable(element, checkVisibility) {
  if (checkVisibility === void 0) {
    checkVisibility = true;
  }

  if (element.tagName) {
    var tagName = element.tagName.toLowerCase();
    var tabIndex = element.getAttribute('tabIndex');
    var skipTab = tabIndex === '-1';
    var focusable = tabIndex !== null && !skipTab;

    if (focusableRegex.test(tagName)) {
      focusable = !element.disabled && !skipTab;
    }

    return focusable && (!checkVisibility || isVisible(element));
  }

  return false;
};
/**
 * @hidden
 */

export var findElement = function findElement(node, predicate, matchSelf) {
  if (matchSelf === void 0) {
    matchSelf = true;
  }

  if (!node) {
    return;
  }

  if (matchSelf && predicate(node)) {
    return node;
  }

  node = node.firstChild;

  while (node) {
    if (node.nodeType === 1) {
      var element = findElement(node, predicate);

      if (element) {
        return element;
      }
    }

    node = node.nextSibling;
  }
};
/**
 * @hidden
 */

export var findFocusable = function findFocusable(element, checkVisibility) {
  if (checkVisibility === void 0) {
    checkVisibility = true;
  }

  return findElement(element, function (node) {
    return isFocusable(node, checkVisibility);
  });
};
/**
 * @hidden
 */

export var findFocusableChild = function findFocusableChild(element, checkVisibility) {
  if (checkVisibility === void 0) {
    checkVisibility = true;
  }

  return findElement(element, function (node) {
    return isFocusable(node, checkVisibility);
  }, false);
};